import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useCallback } from 'react';
import { BUOY_BAZAAR_API } from 'src/interviews/requests/settings';

export interface IInsurancePlan {
  name: string;
  token: string;
}

type Response = IInsurancePlan[];

function useInsuranceCarriers() {
  const fetcher = useCallback(async () => {
    const response = await axios.get(`${BUOY_BAZAAR_API}/insurance-carrier-plans/`);
    return response.data;
  }, []);

  return useQuery<Response>({
    queryKey: ['bazaar-insurance-carrier-plans'],
    queryFn: fetcher,
    retry: false,
  });
}

export default useInsuranceCarriers;
